import { render, staticRenderFns } from "./chooseFont.vue?vue&type=template&id=d987819e&scoped=true"
import script from "./chooseFont.vue?vue&type=script&lang=js"
export * from "./chooseFont.vue?vue&type=script&lang=js"
import style0 from "./chooseFont.vue?vue&type=style&index=0&id=d987819e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d987819e",
  null
  
)

export default component.exports